import React from "react";
import styled from "styled-components";

export const HideTablet = styled.div`
  display: none;
  width: ${({ inline = false }) => (inline ? "auto" : "100%")};

  ${props => props.theme.media.card`
    display: block;
  `};
`;

export const HideDesktop = styled.div`
  width: ${({ inline = false }) => (inline ? "auto" : "100%")};
  ${props => props.theme.media.card`
    display: none;
  `};
`;

export const ShowMobile = styled.div`
  width: ${({ inline = false }) => (inline ? "auto" : "100%")};
  display: none;
  ${props => props.theme.media.mobile`
    display: block;
  `};
`;

export const HideMobile = styled.div`
  width: ${({ inline = false }) => (inline ? "auto" : "100%")};
  ${props => props.theme.media.mobile`
    display: none;
  `};
`;



// WEBPACK FOOTER //
// ./src/components/blocks/Responsive.js